module.exports = __webpack_public_path__ + "img/gn.247b5d82.svg";